<template>
  <div class="w-full flex flex-col px-6 pt-20">
    <div class="slider-cont w-full">
      <div class="slider-wrapper relative">
        <VueSlickCarousel
          ref="itemAwakeningSlider"
          v-bind="settings"
          @beforeChange="beforeChangeCarousel"
        >
          <div class="awakening-slide">
            <h1
              class="w-full text-center font-rakkas 3sm:text-8.4xl sm:text-5 xs:text-30 text-white"
            >
              Item Awakening
            </h1>
            <div
              class="font-mulish-bold bg-very-dark-violet py-2 3sm:text-2 xs:text-1.2 xs:tracking-wider text-white text-center"
            >
              You can upgrade your gear even more with awakening!<br />
              <span class="text-light-violet"
                >Try them out in your inventory window!</span
              >
            </div>
            <div class="w-full flex flex-col justify-center items-center">
              <span
                class="3sm:w-504 3sm:h-3.5 xs:w-203 xs:h-8 text-center bg-vivid-pink font-mulish-bold text-white 3sm:text-1.8 xs:text-1.4 leading-1.6 3sm:tracking-wider xs:tracking-normal py-1 flex items-center justify-center mt-12"
                >1. Item Awakening Window</span
              >
              <div class="w-full mt-8 flex justify-center">
                <img
                  class="3sm:w-10/12 xs:w-full"
                  :src="`${imgPath}/SystemChanges/awakening_01.png`"
                  alt="awakening"
                />
              </div>
              <div class="w-full flex justify-center items-center mt-12">
                <div
                  class="flex justify-center items-center p-3 bg-white rounded-3xl"
                >
                  <div
                    class="h-full flex justify-center items-center bg-very-pale-orange rounded-2xl shadow-sc-box 3sm:p-11 2sm:p-6 xs:p-4"
                  >
                    <ul
                      class="list-none h-full flex flex-col justify-center items-start"
                    >
                      <li
                        class="w-full flex flex-row mt-1 first:mt-0"
                        v-for="(item, index) in itemAwakening1"
                        :key="index"
                      >
                        <div class="w-1/12">
                          <span
                            class="bg-vivid-pink 3sm:w-2.8 3sm:h-2.8 xs:w-10 xs:h-10 font-mulish-bold 3sm:text-1.4 xs:text-1.2 text-white flex justify-center items-center 3sm:rounded-2xl xs:rounded-xl"
                            v-html="item.order"
                          ></span>
                        </div>
                        <p
                          class="2sm:ml-0 xs:ml-5 pt-2 font-mulish-semibold text-very-dark-gray 3sm:text-1.4 xs:text-1.2"
                          v-html="item.desc"
                        ></p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="awakening-slide">
            <div class="w-full flex flex-col justify-center items-center mt-20">
              <span
                class="3sm:w-266 3sm:h-3.5 xs:w-203 xs:h-8 text-center bg-vivid-pink font-mulish-bold text-white 3sm:text-1.8 xs:text-1.4 leading-2.2 tracking-wider flex items-center justify-center px-2"
                >2. Awakening Progress</span
              >
              <div
                class="w-full mt-8 flex flex-col items-center justify-center"
              >
                <img
                  class="w-full"
                  :src="`${imgPath}/SystemChanges/awakening_02.png`"
                  alt="awakening"
                />
                <div class="w-full flex flex-row justify-center mt-5">
                  <div class="w-6/12 flex flex-col justify-center items-center">
                    <h3
                      class="font-mulish-extra-bold text-very-pale-orange 3sm:text-2 xs:text-1.2 3sm:leading-2.2 xs:leading-1.4 tracking-wider"
                    >
                      Succeeding Equipment
                    </h3>
                    <h3
                      class="font-mulish-medium text-very-pale-orange 3sm:text-2 xs:text-1.2 3sm:leading-2.2 xs:leading-1.4 tracking-wider"
                    >
                      Awakening Progress
                    </h3>
                  </div>
                  <div class="w-6/12 flex flex-col justify-center items-center">
                    <h3
                      class="font-mulish-extra-bold text-very-pale-orange 3sm:text-2 xs:text-1.2 3sm:leading-2.2 xs:leading-1.4 tracking-wider"
                    >
                      Failing Equipment
                    </h3>
                    <h3
                      class="font-mulish-medium text-very-pale-orange 3sm:text-2 xs:text-1.2 3sm:leading-2.2 xs:leading-1.4 tracking-wider"
                    >
                      Awakening Progress
                    </h3>
                  </div>
                </div>
              </div>
              <div class="flex justify-center items-center mt-20">
                <div
                  class="flex justify-center items-center p-3 bg-white rounded-3xl"
                >
                  <div
                    class="h-full flex justify-center items-center bg-very-pale-orange rounded-2xl shadow-sc-box 3sm:p-11 xs:p-3"
                  >
                    <p
                      class="w-full max-w-75 font-mulish-semibold 3sm:text-1.8 xs:text-1.2 3sm:leading-2.2 xs:leading-1.4 text-very-dark-gray text-center px-4 py-4"
                    >
                      Success / failure proceeds in order from options 1 to 4.
                      If an option fails, all of the next options will fail
                      unconditionally.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>
        <div class="w-full flex justify-center mt-5">
          <div
            class="w-226 flex justify-center items-center px-4 h-54 bg-black bg-opacity-30 rounded-3xl"
          >
            <span
              :class="
                index === activeSlide
                  ? 'bg-dark-moderate-violet'
                  : 'bg-very-dark-violet'
              "
              class="w-6 h-6 rounded-full mx-5 z-10 cursor-pointer"
              v-for="(item, index) in [0, 1]"
              :key="index"
              @click="goToSlide(index)"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
export default {
  components: { VueSlickCarousel },
  data: function() {
    return {
      activeSlide: 0,
      settings: {
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },
  methods: {
    beforeChangeCarousel: function(oldIndex, newIndex) {
      this.activeSlide = newIndex;
    },
    goToSlide: function(index) {
      this.activeSlide = index;
      this.$refs.itemAwakeningSlider.goTo(index);
    },
  },
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
      itemAwakening1: state => state.SystemChanges.itemAwakening1,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.slider-wrapper >>> .slick-track {
  @apply flex justify-center items-center !important;
}
</style>
